<template>
  <svg
    v-if="gSiteName === 'xoilaczxc'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="as-not-change-color"
  >
    <g clip-path="url(#clip0_15_4710)">
      <path
        d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM13.3333 14.5L9.16667 10.3333V3.33333H10.8333V9.66667L14.5 13.3333L13.3333 14.5Z"
        fill="#7E8793"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_4710">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="gSiteName === 'xoilactivi'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="as-not-change-color"
  >
    <g clip-path="url(#clip0_491_522)">
      <path
        d="M10 16.875C13.7938 16.875 16.875 13.7938 16.875 10C16.875 6.20624 13.7938 3.125 10 3.125C6.20624 3.125 3.125 6.20624 3.125 10C3.125 13.7938 6.20624 16.875 10 16.875ZM9.375 5.8625C9.375 5.5125 9.65626 5.2375 10 5.2375C10.3437 5.2375 10.625 5.5125 10.625 5.8625V9.375H12.375C12.725 9.375 13 9.65626 13 10C13 10.3437 12.725 10.625 12.375 10.625H10C9.65626 10.625 9.375 10.3437 9.375 10V5.8625Z"
        fill="#B4BEC1"
      />
      <path
        d="M10 19.375C15.1688 19.375 19.375 15.1687 19.375 10C19.375 4.83124 15.1688 0.625 10 0.625C4.83124 0.625 0.625 4.83124 0.625 10C0.625 15.1687 4.83124 19.375 10 19.375ZM10 1.875C14.4812 1.875 18.125 5.51872 18.125 10C18.125 14.4812 14.4812 18.125 10 18.125C5.51876 18.125 1.875 14.4812 1.875 10C1.875 5.51872 5.51876 1.875 10 1.875Z"
        fill="#00FF5E"
      />
    </g>
    <defs>
      <clipPath id="clip0_491_522">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="4" width="8" height="2.6" fill="#9C9C9C" />
    <rect x="5" y="9.2002" width="5" height="2.6" fill="#9C9C9C" />
    <rect x="4" y="14.4004" width="6" height="2.6" fill="#9C9C9C" />
    <rect x="11" y="4" width="5" height="2.6" fill="#9C9C9C" />
    <rect x="11" y="9.2002" width="3" height="2.6" fill="#9C9C9C" />
    <rect x="11" y="14.4004" width="8" height="2.6" fill="#9C9C9C" />
  </svg>
</template>
<script lang="ts">
export default {};
</script>
